import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import './assets/styles/global.css';
import './filters';

Vue.config.productionTip = false;
window.app = new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
